(() => {
  'use strict';
  const qsa=(s,r=document)=>[...r.querySelectorAll(s)];
  const qs=(s,r=document)=>r.querySelector(s);
  const clamp=(v,a,b)=>Math.min(Math.max(v,a),b);
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;


  const headerHeight=()=>document.querySelector('[data-site-header]')?.getBoundingClientRect().height||0;
  const syncHeaderHeight=()=>document.documentElement.style.setProperty('--header-height',`${Math.round(headerHeight())}px`);
  syncHeaderHeight();
  addEventListener('resize',syncHeaderHeight,{passive:true});
  const absoluteTop=section=>window.scrollY+section.getBoundingClientRect().top;
  const frameTop=section=>Math.max(0,absoluteTop(section)-headerHeight());
  const frameEnd=section=>Math.max(0,absoluteTop(section)+section.getBoundingClientRect().height-window.innerHeight);
  const sectionHost=section=>section?.closest?.('.shopify-section')||section;
  const adjacentSection=(section,direction='down')=>{
    let node=sectionHost(section);
    const prop=direction==='up'?'previousElementSibling':'nextElementSibling';
    while(node){
      node=node[prop];
      if(!node)break;
      const candidate=node.matches?.('section')?node:node.querySelector?.('section');
      if(candidate)return candidate;
    }
    // Static/non-Shopify preview fallback.
    let direct=section?.[prop];
    while(direct){
      if(direct.matches?.('section'))return direct;
      const candidate=direct.querySelector?.('section');
      if(candidate)return candidate;
      direct=direct[prop];
    }
    return null;
  };
  let kgmFrameSnapping=false;
  let kgmFrameRaf=0;
  let kgmFrameToken=0;
  const scrollFrameTo=(top)=>{
    const target=Math.max(0,Math.round(top));
    kgmFrameSnapping=true;
    const token=++kgmFrameToken;
    if(kgmFrameRaf)cancelAnimationFrame(kgmFrameRaf);
    window.scrollTo({top:target,behavior:reduce?'auto':'smooth'});
    const started=performance.now();
    let stable=0,last=window.scrollY;
    const settle=()=>{
      if(token!==kgmFrameToken)return;
      const now=window.scrollY;
      const close=Math.abs(now-target)<=3;
      const still=Math.abs(now-last)<.5;
      stable=close&&still?stable+1:0;
      last=now;
      if(reduce||stable>=2||performance.now()-started>1050){
        window.scrollTo({top:target,behavior:'auto'});
        kgmFrameSnapping=false;
        kgmFrameRaf=0;
        document.dispatchEvent(new CustomEvent('kgm:frame-settled',{detail:{top:target}}));
        return;
      }
      kgmFrameRaf=requestAnimationFrame(settle);
    };
    kgmFrameRaf=requestAnimationFrame(settle);
  };
  const snapFrame=(section,edge='start',direction='down')=>{
    if(!section)return;
    if(section.matches('[data-kgm-cinema]')){
      const vp=qs('[data-cinema-viewport]',section);
      if(vp){
        const max=Math.max(0,vp.scrollWidth-vp.clientWidth);
        vp.scrollLeft=direction==='up'?max:0;
        vp.dispatchEvent(new Event('scroll'));
      }
    }
    scrollFrameTo(edge==='end'?frameEnd(section):frameTop(section));
  };
  const isFrameAligned=section=>Math.abs(section.getBoundingClientRect().top-headerHeight())<14;
  const isFrameMostlyVisible=section=>{
    const r=section.getBoundingClientRect(),hh=headerHeight(),vh=window.innerHeight;
    const visible=Math.max(0,Math.min(r.bottom,vh)-Math.max(r.top,hh));
    return visible/Math.max(1,Math.min(r.height,vh-hh))>.42;
  };
  let kgmScrollDirection='down',kgmLastScrollY=window.scrollY;
  addEventListener('scroll',()=>{const y=window.scrollY;if(Math.abs(y-kgmLastScrollY)>1)kgmScrollDirection=y>=kgmLastScrollY?'down':'up';kgmLastScrollY=y;},{passive:true});

  function initTransitions(root=document){
    const sections=qsa('[data-lux-transition]',root);
    if(!sections.length)return;
    sections.forEach(section=>section.classList.add('is-lux-revealed'));
    if(reduce)return;
    let lastY=window.scrollY, direction='down';
    const onScroll=()=>{const y=window.scrollY;direction=y>=lastY?'down':'up';lastY=y;};
    addEventListener('scroll',onScroll,{passive:true});
    const timers=new WeakMap();
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      const section=entry.target;
      if(!entry.isIntersecting){section.dataset.luxInside='0';return;}
      if(section.dataset.luxInside==='1')return;
      section.dataset.luxInside='1';
      section.classList.remove('lux-play-down','lux-play-up');
      void section.offsetWidth;
      section.classList.add(direction==='up'?'lux-play-up':'lux-play-down');
      clearTimeout(timers.get(section));
      timers.set(section,setTimeout(()=>section.classList.remove('lux-play-down','lux-play-up'),920));
    }),{threshold:.12,rootMargin:'-4% 0px -4%'});
    sections.forEach(section=>observer.observe(section));
  }

  function initTheatre(root=document){
    qsa('[data-kgm-theatre]',root).forEach(section=>{
      if(section.dataset.v20Ready)return; section.dataset.v20Ready='1';
      const objects=qsa('[data-theatre-object]',section), buttons=qsa('[data-theatre-select]',section), current=qs('[data-theatre-current]',section), ambient=qs('.kgm-theatre__ambient',section), drawers=qsa('[data-theatre-drawer]',section);
      let active=0,lastTrigger=null;
      const THEATRE_MODEL_START_ORBIT='35deg 66deg 180%';
      const THEATRE_MODEL_MIN_ORBIT='auto 35deg 70%';
      const THEATRE_MODEL_MAX_ORBIT='auto 85deg 180%';
      const THEATRE_MODEL_AUTOROTATE_DELAY=1500;

      const configureTheatreModel=model=>{
        if(!model)return;
        model.setAttribute('camera-controls','');
        model.setAttribute('auto-rotate','');
        model.setAttribute('auto-rotate-delay',String(THEATRE_MODEL_AUTOROTATE_DELAY));
        model.setAttribute('rotation-per-second','16deg');
        model.setAttribute('camera-target','auto auto auto');
        model.setAttribute('camera-orbit',THEATRE_MODEL_START_ORBIT);
        model.setAttribute('min-camera-orbit',THEATRE_MODEL_MIN_ORBIT);
        model.setAttribute('max-camera-orbit',THEATRE_MODEL_MAX_ORBIT);
        model.setAttribute('interaction-prompt','none');
        const resetCamera=()=>{
          model.setAttribute('camera-orbit',THEATRE_MODEL_START_ORBIT);
          model.setAttribute('camera-target','auto auto auto');
          try{model.jumpCameraToGoal?.();}catch(_){}
          try{model.dismissPoster?.();}catch(_){}
        };
        if(model.loaded)resetCamera();
        else model.addEventListener('load',resetCamera,{once:true});
        model._kgmResetCamera=resetCamera;
      };

      const initDrawerMedia=drawer=>{
        const viewport=qs('[data-theatre-media-viewport]',drawer);
        const slides=qsa('[data-theatre-media-slide]',drawer);
        const prev=qs('[data-theatre-media-prev]',drawer);
        const next=qs('[data-theatre-media-next]',drawer);
        const currentMedia=qs('[data-theatre-media-current]',drawer);
        const totalMedia=qs('[data-theatre-media-total]',drawer);
        const dots=qs('[data-theatre-media-dots]',drawer);
        const model=qs('model-viewer',drawer);
        if(!viewport||!slides.length)return;
        configureTheatreModel(model);

        let mediaIndex=0,wheelLocked=false,scrollRaf=0;
        if(totalMedia)totalMedia.textContent=String(slides.length).padStart(2,'0');

        const setModelRotation=on=>{
          if(!model)return;
          if(on)model.setAttribute('auto-rotate','');
          else model.removeAttribute('auto-rotate');
        };

        const sync=(index,behavior='smooth')=>{
          mediaIndex=clamp(index,0,slides.length-1);
          const target=slides[mediaIndex];
          viewport.scrollTo({top:target.offsetTop,behavior:reduce?'auto':behavior});
          slides.forEach((slide,i)=>{
            const on=i===mediaIndex;
            slide.classList.toggle('is-active',on);
            slide.setAttribute('aria-hidden',String(!on));
          });
          if(currentMedia)currentMedia.textContent=String(mediaIndex+1).padStart(2,'0');
          if(prev)prev.disabled=mediaIndex===0;
          if(next)next.disabled=mediaIndex===slides.length-1;
          qsa('button',dots).forEach((dot,i)=>dot.classList.toggle('is-active',i===mediaIndex));
          setModelRotation(mediaIndex===0);
          if(mediaIndex===0)model?._kgmResetCamera?.();
        };

        if(dots){
          dots.replaceChildren();
          slides.forEach((slide,i)=>{
            const dot=document.createElement('button');
            dot.type='button';
            dot.setAttribute('aria-label',i===0?'Show interactive 3D model':`Show product image ${i}`);
            dot.addEventListener('click',()=>sync(i));
            dots.appendChild(dot);
          });
        }

        prev?.addEventListener('click',()=>sync(mediaIndex-1));
        next?.addEventListener('click',()=>sync(mediaIndex+1));

        viewport.addEventListener('scroll',()=>{
          if(scrollRaf)return;
          scrollRaf=requestAnimationFrame(()=>{
            scrollRaf=0;
            const h=Math.max(1,viewport.clientHeight);
            const nextIndex=clamp(Math.round(viewport.scrollTop/h),0,slides.length-1);
            if(nextIndex===mediaIndex)return;
            mediaIndex=nextIndex;
            slides.forEach((slide,i)=>{
              const on=i===mediaIndex;
              slide.classList.toggle('is-active',on);
              slide.setAttribute('aria-hidden',String(!on));
            });
            if(currentMedia)currentMedia.textContent=String(mediaIndex+1).padStart(2,'0');
            if(prev)prev.disabled=mediaIndex===0;
            if(next)next.disabled=mediaIndex===slides.length-1;
            qsa('button',dots).forEach((dot,i)=>dot.classList.toggle('is-active',i===mediaIndex));
            setModelRotation(mediaIndex===0);
          });
        },{passive:true});

        // Normal wheel/trackpad = next/previous media.
        // Ctrl/Cmd + wheel over 3D remains available for model zoom.
        viewport.addEventListener('wheel',e=>{
          if(e.target.closest('model-viewer')&&(e.ctrlKey||e.metaKey))return;
          if(Math.abs(e.deltaY)<8)return;
          e.preventDefault();
          e.stopPropagation();
          if(wheelLocked)return;
          wheelLocked=true;
          sync(mediaIndex+(e.deltaY>0?1:-1));
          setTimeout(()=>{wheelLocked=false;},520);
        },{passive:false,capture:true});

        drawer._kgmResetMedia=()=>{
          viewport.scrollTop=0;
          mediaIndex=0;
          configureTheatreModel(model);
          sync(0,'auto');
        };
        sync(0,'auto');
      };
      drawers.forEach(initDrawerMedia);
      const select=(index)=>{
        active=clamp(index,0,objects.length-1);
        objects.forEach((o,i)=>{
          const on=i===active;
          o.classList.toggle('is-active',on);
          o.setAttribute('aria-hidden',String(!on));
          if(on){o.classList.remove('is-entering');void o.offsetWidth;o.classList.add('is-entering');}
        });
        buttons.forEach((b,i)=>{
          const on=i===active;
          b.classList.toggle('is-active',on);
          b.setAttribute('aria-pressed',String(on));
        });
        if(current)current.textContent=String(active+1).padStart(2,'0');
      };
      const closeDrawers=()=>{drawers.forEach(d=>{d.classList.remove('is-open');d.setAttribute('aria-hidden','true');});section.classList.remove('has-theatre-drawer');document.documentElement.classList.remove('kgm-theatre-lock');document.body?.classList.remove('kgm-theatre-lock');if(lastTrigger?.isConnected)lastTrigger.focus({preventScroll:true});};
      const openDrawer=(id,trigger)=>{const drawer=document.getElementById(id);if(!drawer||!section.contains(drawer))return;closeDrawers();lastTrigger=trigger;drawer._kgmResetMedia?.();drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');section.classList.add('has-theatre-drawer');document.documentElement.classList.add('kgm-theatre-lock');document.body?.classList.add('kgm-theatre-lock');requestAnimationFrame(()=>drawer.querySelector('.kgm-theatre-drawer__close')?.focus({preventScroll:true}));};
      buttons.forEach((b,i)=>b.addEventListener('click',()=>select(i)));
      section.addEventListener('click',e=>{
        const opener=e.target.closest('[data-theatre-open]');
        if(opener){e.preventDefault();e.stopPropagation();openDrawer(opener.dataset.theatreOpen,opener);return;}
        if(e.target.closest('[data-theatre-close]')){e.preventDefault();e.stopPropagation();closeDrawers();}
      });
      section.addEventListener('keydown',e=>{if(e.key==='Escape'&&drawers.some(d=>d.classList.contains('is-open')))closeDrawers();});
      const update=()=>{
        const r=section.getBoundingClientRect(),max=Math.max(1,section.offsetHeight-innerHeight);
        const p=clamp(-r.top/max,0,1),index=Math.min(objects.length-1,Math.floor(p*objects.length));
        select(index);
        const local=(p*objects.length)-index;
        const img=qs('[data-theatre-product] img',objects[index]);
        if(img&&!reduce){
          img.style.setProperty('--lift',`${(local-.5)*-14}px`);
          img.style.setProperty('--rot',`${(local-.5)*7}deg`);
          img.style.setProperty('--scale',String(.97+local*.045));
        }
      };
      addEventListener('scroll',update,{passive:true}); update();
      section.addEventListener('pointermove',e=>{
        if(reduce)return;
        const r=section.getBoundingClientRect();
        const nx=clamp((e.clientX-r.left)/Math.max(1,r.width),0,1);
        const ny=clamp((e.clientY-r.top)/Math.max(1,r.height),0,1);
        ambient?.style.setProperty('--mx',`${nx*100}%`);
        ambient?.style.setProperty('--my',`${ny*100}%`);
        const light=qs('.kgm-theatre__stage-light',section);
        light?.style.setProperty('--px',`${nx*100}%`);
        light?.style.setProperty('--py',`${ny*100}%`);
        const activeObject=objects[active];
        const product=qs('[data-theatre-product]',activeObject);
        const img=product?.querySelector('img');
        if(product&&img){
          const pr=product.getBoundingClientRect();
          const px=clamp((e.clientX-pr.left)/Math.max(1,pr.width),0,1)-.5;
          const py=clamp((e.clientY-pr.top)/Math.max(1,pr.height),0,1)-.5;
          if(e.clientX>=pr.left&&e.clientX<=pr.right&&e.clientY>=pr.top&&e.clientY<=pr.bottom){
            img.style.setProperty('--hover-x',`${px*8}px`);
            img.style.setProperty('--hover-y',`${py*5}px`);
            img.style.setProperty('--tilt-x',`${py*-2.2}deg`);
            img.style.setProperty('--tilt-y',`${px*4.5}deg`);
          }else{
            img.style.setProperty('--hover-x','0px');
            img.style.setProperty('--hover-y','0px');
            img.style.setProperty('--tilt-x','0deg');
            img.style.setProperty('--tilt-y','0deg');
          }
        }
      });
      section.addEventListener('pointerleave',()=>{
        const img=qs('[data-theatre-product] img',objects[active]);
        if(!img)return;
        img.style.setProperty('--hover-x','0px');
        img.style.setProperty('--hover-y','0px');
        img.style.setProperty('--tilt-x','0deg');
        img.style.setProperty('--tilt-y','0deg');
      });
    });
  }

  function initRecommended(root=document){
    qsa('[data-kgm-recommended]',root).forEach(section=>{
      if(section.dataset.v26RecommendedReady)return;section.dataset.v26RecommendedReady='1';
      const viewport=qs('[data-recommended-viewport]',section),cards=qsa('.kgm-recommended__card',section);if(!viewport||!cards.length)return;
      const step=()=>cards[0].getBoundingClientRect().width+18;
      const move=dir=>viewport.scrollBy({left:step()*dir,behavior:reduce?'auto':'smooth'});
      qs('[data-recommended-prev]',section)?.addEventListener('click',()=>move(-1));
      qs('[data-recommended-next]',section)?.addEventListener('click',()=>move(1));
      section.addEventListener('wheel',e=>{
        if(Math.abs(e.deltaX)>Math.abs(e.deltaY)||Math.abs(e.deltaY)<2)return;
        if(kgmFrameSnapping){e.preventDefault();return;}
        // If the chapter is only partially visible, the first wheel settles it into the frame.
        if(!isFrameAligned(section)){
          if(isFrameMostlyVisible(section)){e.preventDefault();snapFrame(section,'start',e.deltaY>0?'down':'up');}
          return;
        }
        e.preventDefault();
        const direction=e.deltaY>0?'down':'up';
        const sibling=adjacentSection(section,direction);
        if(!sibling)return;
        snapFrame(sibling,direction==='down'?'start':'end',direction);
      },{passive:false});
    });
  }

  function initMaterial(root=document){
    qsa('[data-kgm-material]',root).forEach(section=>{
      if(section.dataset.v18Ready)return; section.dataset.v18Ready='1'; const steps=qsa('[data-material-step]',section), pins=qsa('[data-material-pin]',section), obj=qs('[data-material-object]',section); let active=0;
      const select=i=>{active=clamp(i,0,steps.length-1);steps.forEach((s,n)=>s.classList.toggle('is-active',n===active));};
      pins.forEach((p,i)=>p.addEventListener('click',()=>select(i)));
      const update=()=>{const r=section.getBoundingClientRect(),max=Math.max(1,section.offsetHeight-innerHeight),p=clamp(-r.top/max,0,1),i=Math.min(steps.length-1,Math.floor(p*steps.length));select(i);if(obj&&!reduce){obj.style.setProperty('--my',`${(p-.5)*-38}px`);obj.style.setProperty('--mr',`${(p-.5)*20}deg`);obj.style.setProperty('--ms',String(.94+p*.13));}}; addEventListener('scroll',update,{passive:true});update();
    });
  }

  function initCinema(root=document){
    qsa('[data-kgm-cinema]',root).forEach(section=>{
      if(section.dataset.v26CinemaReady)return;section.dataset.v26CinemaReady='1';
      const viewport=qs('[data-cinema-viewport]',section),cards=qsa('[data-cinema-card]',section),progress=qs('[data-cinema-progress]',section);if(!viewport||!cards.length)return;
      let down=false,startX=0,startScroll=0,pointerId=null,dragged=false,suppressClickUntil=0,wheelTarget=viewport.scrollLeft,wheelRaf=0;
      const maxScroll=()=>Math.max(0,viewport.scrollWidth-viewport.clientWidth);
      const step=()=>cards[0].getBoundingClientRect().width+24;
      const updateProgress=()=>{const max=maxScroll();if(progress)progress.style.width=`${max?20+(viewport.scrollLeft/max)*80:100}%`;};
      const stopWheel=(snap=null)=>{if(wheelRaf){cancelAnimationFrame(wheelRaf);wheelRaf=0;}if(snap!==null){viewport.scrollLeft=snap;wheelTarget=snap;}updateProgress();};
      const animateWheel=()=>{wheelRaf=0;const diff=wheelTarget-viewport.scrollLeft;if(Math.abs(diff)<.5){viewport.scrollLeft=wheelTarget;updateProgress();return;}viewport.scrollLeft+=diff*(reduce?1:.22);updateProgress();wheelRaf=requestAnimationFrame(animateWheel);};
      const setWheelTarget=v=>{wheelTarget=clamp(v,0,maxScroll());if(!wheelRaf)wheelRaf=requestAnimationFrame(animateWheel);};
      const nearest=()=>clamp(Math.round(viewport.scrollLeft/step()),0,cards.length-1);
      const go=i=>{stopWheel();viewport.scrollTo({left:clamp(i,0,cards.length-1)*step(),behavior:reduce?'auto':'smooth'});};
      qs('[data-cinema-prev]',section)?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();go(nearest()-1);});
      qs('[data-cinema-next]',section)?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();go(nearest()+1);});

      viewport.addEventListener('scroll',()=>{if(!down&&!wheelRaf)wheelTarget=viewport.scrollLeft;updateProgress();},{passive:true});
      section.addEventListener('wheel',e=>{
        const verticalDominant=Math.abs(e.deltaY)>=Math.abs(e.deltaX);
        const delta=verticalDominant?e.deltaY:e.deltaX;
        if(Math.abs(delta)<1)return;
        if(kgmFrameSnapping){if(verticalDominant)e.preventDefault();return;}
        // Never let Five Spaces operate while it is sitting between two sections.
        if(!isFrameAligned(section)){
          if(verticalDominant&&isFrameMostlyVisible(section)){e.preventDefault();snapFrame(section,'start',delta>0?'down':'up');}
          return;
        }
        const max=maxScroll();
        const logical=wheelRaf?wheelTarget:viewport.scrollLeft;
        const atStart=logical<=2&&viewport.scrollLeft<=3;
        const atEnd=logical>=max-2&&viewport.scrollLeft>=max-3;
        if(verticalDominant&&delta<0&&atStart){
          e.preventDefault();stopWheel(0);
          const prev=adjacentSection(section,'up');
          if(prev)snapFrame(prev,'end','up');
          return;
        }
        if(verticalDominant&&delta>0&&atEnd){
          e.preventDefault();stopWheel(max);
          const next=adjacentSection(section,'down');
          if(next)snapFrame(next,'start','down');
          return;
        }
        if(!verticalDominant&&((delta<0&&atStart)||(delta>0&&atEnd)))return;
        e.preventDefault();
        if(!wheelRaf)wheelTarget=viewport.scrollLeft;
        setWheelTarget(wheelTarget+delta*1.18);
      },{passive:false});

      viewport.addEventListener('pointerdown',e=>{
        if(e.target.closest('.kgm-cinema__enter'))return;
        if(e.pointerType==='mouse'&&e.button!==0)return;
        down=true;dragged=false;pointerId=e.pointerId;startX=e.clientX;startScroll=viewport.scrollLeft;wheelTarget=viewport.scrollLeft;
        viewport.classList.add('is-dragging');viewport.setPointerCapture?.(e.pointerId);
      });
      viewport.addEventListener('pointermove',e=>{
        if(!down||e.pointerId!==pointerId)return;
        const dx=e.clientX-startX;if(Math.abs(dx)>7)dragged=true;
        viewport.scrollLeft=clamp(startScroll-dx,0,maxScroll());wheelTarget=viewport.scrollLeft;updateProgress();
      });
      const endDrag=e=>{if(!down)return;down=false;viewport.classList.remove('is-dragging');try{viewport.releasePointerCapture?.(pointerId);}catch(_){}pointerId=null;if(dragged){suppressClickUntil=performance.now()+220;const idx=nearest();setTimeout(()=>go(idx),16);}};
      viewport.addEventListener('pointerup',endDrag);viewport.addEventListener('pointercancel',endDrag);

      const openRoom=key=>{
        if(!key)return;
        document.dispatchEvent(new CustomEvent('kgm:open-room',{detail:{room:key,scroll:false}}));
        const maison=document.querySelector('[data-kgmj]');
        if(maison) maison.scrollIntoView({behavior:'auto',block:'start'});
      };
      section.addEventListener('click',e=>{
        const trigger=e.target.closest('[data-cinema-enter-room]');
        if(!trigger)return;
        if(performance.now()<suppressClickUntil&&!e.target.closest('.kgm-cinema__enter'))return;
        e.preventDefault();e.stopPropagation();
        openRoom(trigger.dataset.cinemaEnterRoom||trigger.dataset.roomKey);
      },true);
      cards.forEach(card=>{
        card.addEventListener('keydown',e=>{if((e.key==='Enter'||e.key===' ')&&!e.target.closest('button')){e.preventDefault();openRoom(card.dataset.roomKey);}});
        card.addEventListener('pointermove',e=>{const c=qs('.kgm-cinema__cursor',card);if(!c)return;const r=card.getBoundingClientRect();c.style.setProperty('--cx',`${e.clientX-r.left}px`);c.style.setProperty('--cy',`${e.clientY-r.top}px`);});
      });
      updateProgress();
    });
  }

  function initChapterFrames(root=document){
    const frames=qsa('[data-kgm-recommended],[data-kgm-cinema],[data-kgm-end-frame]',root);
    if(!frames.length||reduce)return;
    frames.forEach(section=>{
      if(section.dataset.v26FrameReady)return;section.dataset.v26FrameReady='1';
      let armed=true,lastAuto=0;
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(!entry.isIntersecting){armed=true;return;}
        if(kgmFrameSnapping||!armed||isFrameAligned(section))return;
        const now=performance.now();
        if(now-lastAuto<900)return;
        const rect=entry.target.getBoundingClientRect(),hh=headerHeight(),vh=window.innerHeight;
        const centered=rect.top<hh+vh*.64&&rect.bottom>hh+vh*.36;
        if(entry.intersectionRatio<.38||!centered)return;
        armed=false;lastAuto=now;
        snapFrame(entry.target,'start',kgmScrollDirection);
      }),{threshold:[.25,.38,.5,.68]});
      observer.observe(section);
      document.addEventListener('kgm:frame-settled',()=>{
        if(!isFrameMostlyVisible(section))armed=true;
      });
    });

    // Wheel/trackpad scrolling can skip an IntersectionObserver threshold in a single frame.
    // After the scroll gesture settles, finish any partially entered chapter automatically.
    if(!document.documentElement.dataset.kgmV26FrameSettleReady){
      document.documentElement.dataset.kgmV26FrameSettleReady='1';
      let settleTimer=0;
      addEventListener('scroll',()=>{
        clearTimeout(settleTimer);
        if(kgmFrameSnapping)return;
        settleTimer=setTimeout(()=>{
          if(kgmFrameSnapping)return;
          const all=qsa('[data-kgm-recommended],[data-kgm-cinema],[data-kgm-end-frame]');
          let best=null,bestRatio=0;
          all.forEach(section=>{
            if(isFrameAligned(section))return;
            const r=section.getBoundingClientRect(),hh=headerHeight(),vh=innerHeight;
            const visible=Math.max(0,Math.min(r.bottom,vh)-Math.max(r.top,hh));
            const ratio=visible/Math.max(1,Math.min(r.height,vh-hh));
            const centered=r.top<hh+vh*.72&&r.bottom>hh+vh*.28;
            if(centered&&ratio>.34&&ratio>bestRatio){best=section;bestRatio=ratio;}
          });
          if(best)snapFrame(best,'start',kgmScrollDirection);
        },110);
      },{passive:true});
    }
  }

  function initEndFrames(root=document){
    qsa('[data-kgm-end-frame]',root).forEach(section=>{
      if(section.dataset.v27EndReady)return;section.dataset.v27EndReady='1';
      section.addEventListener('wheel',e=>{
        if(Math.abs(e.deltaY)<2||Math.abs(e.deltaX)>Math.abs(e.deltaY))return;
        if(kgmFrameSnapping){e.preventDefault();return;}
        const direction=e.deltaY>0?'down':'up';
        if(!isFrameAligned(section)){
          if(isFrameMostlyVisible(section)){e.preventDefault();snapFrame(section,direction==='up'?'end':'start',direction);}
          return;
        }
        const sibling=adjacentSection(section,direction);
        if(!sibling)return;
        e.preventDefault();
        snapFrame(sibling,direction==='down'?'start':'end',direction);
      },{passive:false});
    });
  }

  function initTilt(root=document){qsa('[data-tilt-card]',root).forEach(card=>{if(card.dataset.tiltReady)return;card.dataset.tiltReady='1';if(reduce)return;card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;card.style.setProperty('--ty',`${x*4}deg`);card.style.setProperty('--tx',`${y*-4}deg`);});card.addEventListener('pointerleave',()=>{card.style.setProperty('--ty','0deg');card.style.setProperty('--tx','0deg');});});}

  function initConvert(root=document){
    qsa('[data-kgm-convert]',root).forEach(section=>{
      if(section.dataset.v28ConvertReady)return;section.dataset.v28ConvertReady='1';
      const update=()=>{
        const r=section.getBoundingClientRect();
        const p=clamp((innerHeight - r.top)/Math.max(1,innerHeight*.72),0,1);
        section.style.setProperty('--reveal', p.toFixed(4));
      };
      addEventListener('scroll', update, {passive:true});
      addEventListener('resize', update);
      if(!reduce){
        section.addEventListener('pointermove',e=>{
          const r=section.getBoundingClientRect();
          const nx=clamp((e.clientX-r.left)/Math.max(1,r.width)-.5,-.5,.5);
          const ny=clamp((e.clientY-r.top)/Math.max(1,r.height)-.5,-.5,.5);
          section.style.setProperty('--mx',`${nx*5}deg`);
          section.style.setProperty('--my',`${ny*-3}deg`);
        });
        section.addEventListener('pointerleave',()=>{section.style.setProperty('--mx','0deg');section.style.setProperty('--my','0deg');});
      }
      update();
    });
  }

  const init=root=>{initTransitions(root);initTheatre(root);initRecommended(root);initMaterial(root);initCinema(root);initChapterFrames(root);initEndFrames(root);initTilt(root);initConvert(root)};
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>init()):init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
